import { render, staticRenderFns } from "./NuevoComprobante.vue?vue&type=template&id=0bfdb63c&"
import script from "./NuevoComprobante.vue?vue&type=script&lang=js&"
export * from "./NuevoComprobante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports